import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvitedMemberDto, InviteMemberRequestDto, MemberDto, PasswordLinkCreatedDto, PatchMemberRequestDto } from './models/member.dto';

@Injectable({ providedIn: 'root' })
export class SettingsUsersProvider {
  constructor(private http: HttpClient) {}

  getMembers(): Observable<MemberDto[]> {
    const url = '/api/members';
    return this.http.get<MemberDto[]>(url);
  }

  invite(request: InviteMemberRequestDto): Observable<InvitedMemberDto> {
    const url = '/api/members';
    return this.http.post<InvitedMemberDto>(url, request);
  }

  patch(memberId: number, request: PatchMemberRequestDto): Observable<void> {
    const url = `/api/members/${memberId}`;
    return this.http.patch<void>(url, request);
  }

  deactivate(memberId: number): Observable<void> {
    const url = `/api/members/${memberId}/deactivate`;
    return this.http.patch<void>(url, null);
  }

  activate(memberId: number): Observable<void> {
    const url = `/api/members/${memberId}/activate`;
    return this.http.patch<void>(url, null);
  }

  issuePasswordLink(memberId: number): Observable<PasswordLinkCreatedDto> {
    const url = `/api/members/${memberId}/password-link`;
    return this.http.post<PasswordLinkCreatedDto>(url, null);
  }

  unlock(memberId: number): Observable<void> {
    const url = `/api/members/${memberId}/unlock`;
    return this.http.patch<void>(url, null);
  }
}
